export const openImage = (base64) => {
    let data = `data:image/png;base64,${base64}`;
    let w = window.open('about:blank');
    let image = new Image();
    image.src = data;
    setTimeout(function(){
    w.document.write(image.outerHTML);
    }, 0);
}